import React from 'react';

import NewsletterTypeSelector from '../../../components/Admin/Newsletter/NewsletterTypeSelector.module';

function NewsletterTypeSelectionView() {
  return <NewsletterTypeSelector />;
}

export default NewsletterTypeSelectionView; 